
import { Accordion, StyledHtml, Text } from "@postenbring/hedwig-react";

export function ServiceSheetAccordion({ supplementaryServices, faq, localization }) {
  const services = supplementaryServices?.lists || [];
  const faqs = faq || [];

  return (
    <>
      {services.length > 0 && (
        <>
        {supplementaryServices.title &&
                                <Text variant="h2" className="hds-mb-24-32">{supplementaryServices.title}</Text>
                            }
                            {supplementaryServices.preface &&
                                <Text as="p" variant="h3" className="hds-mb-24-32">{supplementaryServices.preface}</Text>
                            }
        <Accordion className="hds-mb-24-32">
          {services.map((service, index) => (
            <Accordion.Item key={index}>
              <Accordion.Header>{service.title}</Accordion.Header>
              <Accordion.Content>
                <StyledHtml dangerouslySetInnerHTML={{ __html: service.description }} />
              </Accordion.Content>
            </Accordion.Item>
          ))}
        </Accordion>
        </>
      )}
      {faqs.length > 0 && (
        <>
          <Text variant="h2" className="hds-mb-24-32">{localization.faq}</Text>
          <Accordion className="hds-mb-24-32">
            {faqs.map((faqItem, index) => (
              <Accordion.Item key={index}>
                <Accordion.Header>{faqItem.question}</Accordion.Header>
                <Accordion.Content>
                  <StyledHtml dangerouslySetInnerHTML={{ __html: faqItem.answer }} />
                </Accordion.Content>
              </Accordion.Item>
            ))}
          </Accordion>
        </>
      )}
    </>
  );
}
